const TOTEM_BEARER_TOKEN = 'totem-bearer-token';
const TOTEM_REFRESH_TOKEN = 'totem-refresh-token';
const THEME_KEY = 'theme';

function splitPanelKey(name: string): string {
    return `split-${name}-sizes`;
}

// Auth tokens
export function getAccessToken(): string | null {
    return window.localStorage.getItem(TOTEM_BEARER_TOKEN);
}

export function getRefreshToken(): string | null {
    return window.localStorage.getItem(TOTEM_REFRESH_TOKEN);
}

export function setTokens(accessToken: string, refreshToken?: string): void {
    window.localStorage.setItem(TOTEM_BEARER_TOKEN, accessToken);
    if (refreshToken) window.localStorage.setItem(TOTEM_REFRESH_TOKEN, refreshToken);
}

export function clearTokens(): void {
    window.localStorage.removeItem(TOTEM_BEARER_TOKEN);
    window.localStorage.removeItem(TOTEM_REFRESH_TOKEN);
}

export function hasAccessToken(): boolean {
    return !!window.localStorage.getItem(TOTEM_BEARER_TOKEN);
}

export function hasRefreshToken(): boolean {
    return !!window.localStorage.getItem(TOTEM_REFRESH_TOKEN);
}

// Theme
export function getThemePreference(): string | null {
    return window.localStorage.getItem(THEME_KEY);
}

export function setThemePreference(theme: 'light' | 'dark'): void {
    window.localStorage.setItem(THEME_KEY, theme);
}

// Sidebar
const SIDEBAR_STORAGE_KEY = 'sidebar-state';

export function getSidebarOpen(): boolean | null {
    const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY);
    if (stored === null) return null;
    return stored === 'true';
}

export function setSidebarOpen(open: boolean): void {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open));
}

// Split panels
export function getSplitPanelSizes(name: string): number[] | null {
    try {
        const raw = window.localStorage.getItem(splitPanelKey(name));
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function setSplitPanelSizes(name: string, sizes: number[]): void {
    window.localStorage.setItem(splitPanelKey(name), JSON.stringify(sizes));
}
